import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';


const HowItWorksSection = () => {
  const steps = [
  {
    id: 1,
    icon: 'UserPlus',
    title: 'Create Profile',
    description: 'Sign up and build your profile with skills and experience.'
  },
  {
    id: 2,
    icon: 'Search',
    title: 'Find Jobs',
    description: 'Browse available gigs or post what you need.'
  },
  {
    id: 3,
    icon: 'MessageSquare',
    title: 'Connect',
    description: 'Message directly and agree on terms.'
  },
  {
    id: 4,
    icon: 'CheckCircle',
    title: 'Complete',
    description: 'Get the job done and leave reviews.'
  }];


  return (
    <section className="py-6 sm:py-5 md:py-5 lg:py-6 bg-[#FF6A00]/70 relative overflow-hidden">
      {/* Background Image with Translucent Orange Overlay */}
      <div className="absolute inset-0">
        <img
          src="https://img.rocket.new/generatedImages/rocket_gen_img_14878af94-1771392573639.png"
          alt="Filipino workers collaborating and providing various services in community settings"
          className="w-full h-full object-cover opacity-30" />
        <div className="absolute inset-0 bg-[#FF6A00]/70" />
      </div>
      
      {/* Decorative Elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 right-20 w-64 h-64 bg-white rounded-full blur-3xl" />
        <div className="absolute bottom-10 left-20 w-64 h-64 bg-white rounded-full blur-3xl" />
      </div>
      
      <div className="relative max-w-[1000px] mx-auto px-5 sm:px-6 md:px-5 lg:px-6">
        <div className="text-center mb-6 sm:mb-5 md:mb-5">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full mb-3">
            <Icon name="Lightbulb" size={18} color="#FFFFFF" />
            <span className="text-sm font-semibold text-white">Simple Process</span>
          </div>
          <h2 className="text-2xl sm:text-2xl md:text-2xl lg:text-3xl font-heading font-bold mb-3 text-white">
            How DISKARTE Works
          </h2>
          <p className="text-sm sm:text-sm md:text-sm max-w-[500px] mx-auto text-white/90">
            Get started in four simple steps
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-4 md:gap-4 mb-6 sm:mb-5">
          {steps?.map((step, index) =>
          <div key={step?.id} className="relative">
              <div className="bg-white/95 backdrop-blur-sm rounded-lg p-5 sm:p-4 md:p-4 shadow-lg hover:shadow-xl transition-all duration-300 h-full group hover:-translate-y-1 active:scale-95 touch-manipulation">
                <div className="flex flex-col items-center text-center">
                  <div className="relative mb-4">
                    <div className="w-16 h-16 sm:w-14 sm:h-14 md:w-14 md:h-14 bg-transparent border-2 border-[#FF6A00] rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                      <Icon name={step?.icon} size={26} color="#FF6A00" strokeWidth={1.5} />
                    </div>
                    <div className="absolute -top-2 -right-2 w-7 h-7 bg-[#FF6A00] rounded-full flex items-center justify-center text-white font-heading font-bold text-sm shadow-lg">
                      {step?.id}
                    </div>
                  </div>

                  <h3 className="text-base sm:text-sm md:text-sm font-heading font-bold text-[#1F2937] mb-2">
                    {step?.title}
                  </h3>
                  <p className="text-sm sm:text-xs text-[#6B7280] leading-relaxed">
                    {step?.description}
                  </p>
                </div>
              </div>

              {index < 3 &&
            <div className="hidden lg:block absolute top-1/2 -right-2 transform -translate-y-1/2 z-10">
                  <Icon name="ArrowRight" size={18} color="#FF6A00" strokeWidth={2} />
                </div>
            }
            </div>
          )}
        </div>

        <div className="text-center">
          <div className="inline-flex flex-col sm:flex-col md:flex-row items-center gap-4 sm:gap-3 md:gap-2.5 p-5 sm:p-4 md:p-4 bg-white/95 backdrop-blur-sm rounded-lg shadow-xl w-full sm:w-auto">
            <div className="flex items-center gap-3 sm:gap-2.5">
              <div className="w-12 h-12 sm:w-10 sm:h-10 bg-[#FF6A00] rounded-lg flex items-center justify-center shadow-lg">
                <Icon name="Zap" size={24} color="white" />
              </div>
              <div className="text-left">
                <div className="text-base sm:text-sm md:text-sm font-heading font-bold text-[#1F2937]">
                  Ready to get started?
                </div>
                <div className="text-sm sm:text-xs text-[#6B7280]">
                  Join thousands of satisfied users
                </div>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-2 w-full sm:w-auto">
              <Button
                variant="outline"
                size="md"
                iconName="Search"
                iconPosition="left"
                className="text-sm sm:text-xs border-[#1E73BE] text-[#1E73BE] hover:bg-[#1E73BE]/10 min-h-[44px] w-full sm:w-auto touch-manipulation">
                
                Find Services
              </Button>
              <Button
                variant="default"
                size="md"
                iconName="Briefcase"
                iconPosition="left"
                className="text-sm sm:text-xs bg-[#FF6A00] hover:bg-[#FF7A1A] min-h-[44px] w-full sm:w-auto touch-manipulation">
                
                Offer Services
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default HowItWorksSection;